module.exports = __webpack_public_path__ + "static/img/icon1.98bb5f5e.svg";